import { render, staticRenderFns } from "./LbxCarousel.vue?vue&type=template&id=0b3fc511"
import script from "./LbxCarousel.vue?vue&type=script&lang=js"
export * from "./LbxCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports